import * as yup from 'yup';

export const updateCompanySchema = yup.object().shape({
  maxUsers: yup.number(),
  expirationDate: yup.date().nullable(true),
  companyId: yup.number(),
  crmId: yup.string().nullable(true),
  tenantAccountType: yup.string(),
});
